
//公共库
import { Component, Vue } from "vue-property-decorator";

//本地引入
import { Message } from "element-ui";
import { userFreeze } from "@/api/request/user";
import Pagination from "@/comp/Pagination/index.vue";
import { wordsCategoryList } from "@/api/request/system";
import { getSuperviseRiskImLogList } from "@/api/request/supervise";

//组件
@Component({
  name: "ImSuperviseNew",
  components: {
    Pagination,
  },
})

//界面函数
export default class extends Vue {
  //定义变量
  private list: any[] = [];
  private total: number = 0;
  private categoryList: Array<any> = [];
  private listLoading: boolean = true; // 列表加载

  //修改冻结
  private id: number = 0;
  private hour: string = "";
  private freezeDialog: boolean = false;

  //请求数据
  private listQuery: any = {
    //页码数据
    page: 1,
    page_size: 20,

    //临时数据
    time: [],
    to_uid_str: "", // 接收ID
    from_uid_str: "", // 用户ID

    //上传数据
    cat_id: 0, // 分类
    to_uid: 0, // 接收ID
    from_uid: 0, // 用户ID
    end_time: 0, // 结束时间戳
    begin_time: 0, //结束时间戳
  };

  //创建
  async created() {
    //获取类别
    await this.getCategory();

    //获取数据
    this.getList();
  }

  //获取数据
  private async getList() {
    //显示等待
    this.listLoading = true;

    //数据赋值
    this.listQuery.to_uid = Number(this.listQuery.to_uid_str);
    this.listQuery.from_uid = Number(this.listQuery.from_uid_str);
    if (this.listQuery.time && this.listQuery.time.length == 2) {
      this.listQuery.begin_time = Math.floor(new Date(this.listQuery.time[0]).getTime() / 1000);
      this.listQuery.end_time = Math.floor(new Date(this.listQuery.time[1]).getTime() / 1000);
    } else {
      this.listQuery.begin_time = 0;
      this.listQuery.end_time = 0;
    }

    //获取数据
    const data: any = await getSuperviseRiskImLogList(this.listQuery);

    //数据赋值
    this.list = data.Data.list;
    this.total = data.Data.total;

    //隐藏等待
    setTimeout(() => {
      this.listLoading = false;
    }, 0.5 * 1000);
  }

  //获取类别列表
  private async getCategory() {
    //显示等待
    this.listLoading = true;

    //获取数据
    const { data } = await wordsCategoryList(this.listQuery);

    //数据赋值
    this.categoryList = [];
    for (var i: number = 0; i < data.length; i++) {
      this.categoryList.push(data[i]);
    }
    this.categoryList.unshift({ id: 0, name: "全部分类" });
  }

  //处理查询
  private handleFilter(): void {
    //数据赋值
    this.listQuery.page = 1;

    //获取数据
    this.getList();
  }

  //处理冻结
  private handleDongJie(row: any): void {
    //数据赋值
    this.hour = "24";
    this.id = row.from_uid;

    //显示界面
    this.freezeDialog = true;
  }

  //冻结确认
  private async freezeConfirm() {
    //判断返回
    if (Number(this.hour) == 0) return Message({ message: "请输入时间", type: "error", duration: 5 * 1000 });

    //请求数据
    const res = await userFreeze({ userids: [this.id], status: 7, hour: Number(this.hour) });

    //冻结成功
    if (res.status === 0) {
      //显示提示
      this.$message.success(`冻结成功`);

      //获取数据
      this.getList();
    }

    //隐藏界面
    this.freezeDialog = false;
  }
}
